
import { Vue, Component } from 'vue-property-decorator';
import Results from '@/features/shipment/views/Results.vue';

@Component({
  components: {
    Results,
  },
})
export default class EstimateResults extends Vue {}
